import { Service } from "../shared/Service";

export class TipoDocumentoService extends Service{

  constructor(){
    super('tipoDocumento');
  }

}